var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"c-settings_password"},[_c('h3',[_vm._v("Zmień hasło")]),_vm._v(" "),_c('p',[_vm._v("Zmiany hasła możesz dokonać w portalu.")])])
}]

export { render, staticRenderFns }